import { FC, useContext } from 'react';
import { Skeleton } from '@mui/material';
import styled from 'styled-components';
import { IntroModulesContext } from './IntroModulesContext';
import { IntroModuleStaticType } from '@vs-online-only-app/state';

const Container = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 2;
  max-height: 40vh;
`;

const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const LoadingSkeleton: FC = () => (
  <Skeleton variant="rectangular" height="100%" />
);

const IntroModuleMedia: FC = () => {
  const { currentIntroModule, isLoading } = useContext(IntroModulesContext);

  if (isLoading) {
    return (
      <Container>
        <LoadingSkeleton />
      </Container>
    );
  }
  if (!currentIntroModule) {
    return null;
  }

  const { mediaUrl, placeHolderUrl, type } = currentIntroModule;

  const isVideo = [
    IntroModuleStaticType.loopingVideo,
    IntroModuleStaticType.introVideo,
  ].includes(type);

  const isImage = [IntroModuleStaticType.image].includes(type);

  return (
    <Container>
      {isImage && <Image src={mediaUrl || placeHolderUrl} />}
      {isVideo && (
        <Video
          autoPlay
          loop={type === IntroModuleStaticType.loopingVideo}
          muted
          playsInline
          src={mediaUrl}
          poster={placeHolderUrl}
        />
      )}
    </Container>
  );
};

export default IntroModuleMedia;
